import request from '@/utils/http';
// 表格数据
export const getList = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/getDispatchOrderList`,
        method: 'get',
        params
    });
};

// 发车确认前校验
export const departConfirmBefore = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/departConfirmBefore`,
        method: 'post',
        data
    });
};

// 确定发车确认
export const departConfirm = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/departConfirm`,
        method: 'post',
        data
    });
};

// 列表双击
export const vehicleInformationQuery = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/vehicleInformationQuery`,
        method: 'post',
        data
    });
};

// 列表编辑保存
export const saveItem = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveItem`,
        method: 'post',
        data
    });
};

// 到车确认 + 到车登记
export const asternConfirm2 = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/asternConfirmTwo`,
        method: 'post',
        data
    });
};

// 到车确认
export const asternConfirmOne = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/asternConfirmOne`,
        method: 'post',
        data
    });
};

// 校验参数
export const getControlParamStringValue = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/getControlParamStringValue`,
        method: 'get',
        params
    });
};
export const getCarTypeApi = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/checkCarTypeItem`,
        method: 'post',
        data
    });
};
export const checkCarNameNetItemApi = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/checkCarNameNetItem`,
        method: 'post',
        data
    });
};

// 异常原因登记
export const registerAbnormalDepartReason = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/wholeExceptionMsgInsert`,
        method: 'post',
        data
    });
};

// 发车人工操作校验接口
export const departCheckOperateReason = data => {
    return request({
        url: `/api-srm-web/order/ltms/departCheckOperateReason`,
        method: 'post',
        data
    });
};

// 到车或抵达人工操作校验接口
export const arriveCheckOperateReason = data => {
    return request({
        url: `/api-srm-web/order/ltms/arriveCheckOperateReason`,
        method: 'post',
        data
    });
};

// 保存人工操作原因接口
export const saveOperateReason = data => {
    return request({
        url: `/api-srm-web/order/ltms/saveOperateReason`,
        method: 'post',
        data
    });
};
